export default {
  isAutoLoad: false,
  columns: [
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'year\')}',
      field: 'entryDateYear'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'month\')}',
      field: 'entryDateMonthName'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'condition\')}',
      field: 'conditionTitle'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'max-price\')}',
      field: 'maxDollarPrice'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'min-price\')}',
      field: 'minDollarPrice'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'avg-price\')}',
      field: 'avgDollarPrice'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'suppliers\')}',
      field: 'countSuppliers'
    },
    {
      // eslint-disable-next-line
      title: '${root.L10n(\'quotes\')}',
      field: 'countSupplierQuotes'
    }
  ].map((column) => {
    return { ...column, sortable: { isAvailable: false } }
  }),
  header: {
    isVisible: false
  },
  pagination: {
    isVisible: false
  }
}
